import { render, staticRenderFns } from "./AulasRegente.vue?vue&type=template&id=0ff74506&"
import script from "./AulasRegente.vue?vue&type=script&lang=js&"
export * from "./AulasRegente.vue?vue&type=script&lang=js&"
import style0 from "./AulasRegente.vue?vue&type=style&index=0&id=0ff74506&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports